<template>
  <el-container class="branch-sale-contrast pagination-list">
    <el-main>
      <div class="content">
        <el-col :span="22" class="branch-sale-contrast-search">
          <el-form>
            <el-form-item>
              <el-checkbox v-model="hasZone">是否片区</el-checkbox>
              <el-radio v-model="dateType" label="year">年度</el-radio>
              <el-radio v-model="dateType" label="month">月度</el-radio>
            </el-form-item>

            <el-form-item label="起始时间:" label-width="80px">
              <el-date-picker v-model="searchParams.startTime" :value-format="dateType === 'year' ? 'yyyy' : 'yyyy-MM'" :type="dateType"></el-date-picker>
            </el-form-item>

            <el-form-item label="终止时间:" label-width="80px">
              <el-date-picker v-model="searchParams.endTime" :value-format="dateType === 'year' ? 'yyyy' : 'yyyy-MM'" :type="dateType"></el-date-picker>
            </el-form-item>

            <el-form-item label="所属分公司" label-width="80px" v-show="!hasZone">
              <el-input :title="filiale" v-model="filiale" placeholder="总公司" readonly @click.native.prevent="openDialog"></el-input>
            </el-form-item>

            <el-form-item>
              <el-button @click="search" size="mini">生成</el-button>
            </el-form-item>
          </el-form>
        </el-col>
        <div class="echarts-bar-line" ref="echartsBarLine"></div>
        <select-filiale-dialog
          :dialogVisible="dialogVisible"
          :default-checked-keys="['0005A41F-0000-0000-0000-0000FDA5314A']"
          @setFiliale="setFiliale"
          @setSelectList="setSelectList"
          @closeDialog="closeDialog"></select-filiale-dialog>
      </div>
    </el-main>
  </el-container>
</template>

<script>
import moment from 'moment'
import Vue from 'vue'

import _ from 'lodash'
import SelectFilialeDialog from './publicDialog/select-filiale-dialog.vue'
let echarts = require('echarts/lib/echarts')
require('echarts/lib/component/tooltip')
require('echarts/lib/chart/bar')
Vue.use(echarts)

export default {
  name: 'branch-sale-contrast',
  components: {SelectFilialeDialog},
  data () {
    return {
      dialogVisible: false,
      dateType: 'month',
      hasZone: false,
      // 已选分公司
      selectList: [],
      searchParams: {
        startTime: moment().subtract(5, 'months').format('YYYY-MM'),
        endTime: moment().format('YYYY-MM')
      },
      filiale: ''
    }
  },
  mounted () {
    this.drawEcharts()
    // 监听窗口大小变化重绘echarts
    window.onresize = _.debounce(() => {
      let myCharts = echarts.init(this.$refs.echartsBarLine)
      myCharts.resize()
    }, 100)
    this.search()
  },
  watch: {
    hasZone (val) {
      this.search()
    },
    dateType (val) {
      if (val === 'year') {
        this.searchParams.startTime = this.searchParams.startTime.substr(0, 4)
        this.searchParams.endTime = this.searchParams.endTime.substr(0, 4)
      } else if (val === 'month') {
        this.searchParams.startTime = this.searchParams.startTime + '-01'
        this.searchParams.endTime = this.searchParams.endTime + '-01'
      }
    }
  },
  methods: {
    drawEcharts () {
      let myCharts = echarts.init(this.$refs.echartsBarLine)
      myCharts.setOption({
        title: {
          text: '分公司销售柱状对比图',
          textStyle: {
            color: '#2A2929',
            fontSize: 20
          }
        },
        grid: {
          bottom: 80
        },
        xAxis: {
          type: 'category'
        },
        yAxis: {
        },
        series: []
      })
    },
    openDialog () {
      this.dialogVisible = true
    },
    // 当前选中分公司
    setFiliale (filiale) {
      this.filiale = filiale
    },
    setSelectList (selectList) {
      this.selectList = selectList
      this.dialogVisible = false
    },
    closeDialog () {
      this.dialogVisible = false
    },
    // 按日期排序从后端获得的数据
    formatterData (data) {
      let orderData = {}
      Object.keys(data).sort().forEach(key => {
        orderData[key] = data[key]
      })
      return orderData
    },
    search () {
      if (!this.searchParams.startTime) {
        return this.$message.error('请选择起始时间')
      }
      if (!this.searchParams.endTime) {
        return this.$message.error('请选择终止时间')
      }
      if (new Date(this.searchParams.startTime).getTime() > new Date(this.searchParams.endTime).getTime()) {
        return this.$message.error('起始时间不能大于终止时间')
      }
      let deptIds = this.selectList.map(e => e.id)
      let data = {
        startTime: this.searchParams.startTime,
        endTime: this.searchParams.endTime,
        deptIds: deptIds,
        type: this.dateType,
        zone: this.hasZone ? 'A区,B区,C区' : ''
      }
      let myCharts = echarts.init(this.$refs.echartsBarLine)
      myCharts.showLoading({
        text: '加载中...',
        color: '#47A2FF',
        textColor: '#47A2FF',
        maskColor: 'rgba(255, 255, 255, 0.8)',
        zlevel: 0
      })
      this.$axios.post('/huaao-api/visualReport/filaleHistogram', data).then(res => {
        let saleData = {}
        let xAxisData = []
        let series = []
        // 设置x轴数据
        Object.keys(res.data).forEach(key => {
          // 将id转换成对应公司名
          if (this.selectList.length === 0) {
            saleData[key] = res.data[key]
          } else {
            let keyName = this.selectList.find(item => item.id === key).name
            saleData[keyName] = res.data[key]
          }
          // 设置x轴数据，用其中任意一个公司的数据即可，只需操作一次
          if (xAxisData.length === 0) {
            Object.keys(res.data[key]).sort().forEach(month => {
              xAxisData.push(month)
            })
          }
        })
        // 设置柱状图数据
        Object.keys(saleData).forEach(key => {
          // 后端回传的日期是从大到小，这里调换一下数据顺序
          saleData[key] = this.formatterData(saleData[key])
          for (let i in saleData[key]) {
            // 无值的全部赋值为0
            if (!saleData[key][i]) {
              saleData[key][i] = {}
              saleData[key][i]['account'] = 0
            }
          }
          let currentLineData = Object.values(saleData[key])
          let account = [] // 分公司销售件数数据
          currentLineData.forEach(item => {
            account.push(item.account)
          })
          // 是否片区
          series.push(
            {
              name: key,
              type: 'bar',
              data: account
            })
        })
        myCharts.clear()
        myCharts.setOption({
          title: {
            text: '分公司销售柱状对比图',
            textStyle: {
              color: '#2A2929',
              fontSize: 20
            }
          },
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              type: 'shadow',
              snap: 'true'
            },
            confine: true
          },
          legend: {
            type: 'scroll',
            orient: 'horizontal',
            bottom: 0
          },
          grid: {
            bottom: 80
          },
          yAxis: {
          },
          xAxis: {
            type: 'category',
            data: xAxisData
          },
          series: series
        })
        myCharts.hideLoading()
      }).catch(() => {
        myCharts.hideLoading()
      })
    }
  }
}
</script>

<style lang="scss">
  @import "@/assets/scss/common.scss";

  .el-container.branch-sale-contrast {
    .content {
      height: calc(100% - 80px);

      .branch-sale-contrast-search {
        .el-form {
          display: flex;
          flex-wrap: nowrap;
          overflow-x: scroll;
          height: 46px;
          .el-form-item{
             flex: 0 1 auto;
           }
          .el-form-item:nth-of-type(1){
            min-width: 252px;
          }
          .el-form-item:nth-of-type(4){
            margin-left: 10px;
          }
          .el-form-item:last-of-type{
            margin-left: 50px;
          }
        }
        .el-button{
          padding: 4px 10px;
          border-color: #55ACF1;
          color: #55ACF1;
          span{
            font-size: 12px;
          }
        }
      }
      .echarts-bar-line{
        width: 92%;
        height: 92%;
        min-width: 800px;
        min-height: 600px;
        margin: 50px auto 0;
      }
      .select-filiale{
        .dialog-content {
          height: 500px;
          overflow: auto;
        }
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/custom/page/huaao/visualReport/branch-sale-contrast.vue